import {observer} from 'mobx-react';
import React from 'react';
import {action, makeObservable, observable, runInAction} from 'mobx';
import s from '../../s';
import {add_to_cart} from '../../api';
import ATCButtonTemplate from './atc-button-template';

type Props = {
    label?: string;
    buyNow?: boolean;
    additionalClass?: string;
};

@observer
export default class ATCButton extends React.Component<Props> {
    @observable loading: boolean = false;

    constructor(props: Props) {
        super(props);
        this.atc = this.atc.bind(this);
        makeObservable(this);
    }

    @action
    atc = async (buyNow = false) => {
        this.loading = true;

        if (s.prod.IsCAF && !(s.pcs.caf_input_sizes || s.pcs.caf_valid_sizes)) {
            s.ui.show_caf_doc_sizes = true;
            this.loading = false;
        } else if (s.prod.allowUpload2 && !s.ui.image_uploaded) {
            s.ui.image_uploaded_msg = `Please upload a ${s.prod.DocType} image before adding to cart`;
            this.loading = false;
        } else if (s.si.StoreID === 205164 && ((s.prod.linos && s.prod.linos.length && (!s.pcs.lino_id || !s.pcs.lino_text)) || (s.prod.ProductID === 88937 && (!s.pcs.custom_text_1 || s.pcs.custom_text_1.length < 5)))) {
            s.pcs.atc_error = `A selection for ${s.si.ProductLinoSelectionText || 'Embossed Text'} is required.`;
            this.loading = false;
        } else {
            try {
                await add_to_cart(buyNow);
            } catch (err) {
                console.error(err);
            } finally {
                // approved ria
                runInAction(() => {
                    this.loading = false;
                });
            }
        }
    };

    render() {
        return (
            <ATCButtonTemplate
                loading={this.loading}
                additionalClass={this.props.additionalClass}
                clicked={() => this.atc(this.props.buyNow)}
            />
        );
    }
}
